import axios from 'axios'
import { parseRequestQuery } from './crud-helper';

const API_URL = process.env.REACT_APP_API_URL

const getDashboardData = (postData: any): Promise<any> => {

  const data = parseRequestQuery(postData)
  return axios
    .post(`${API_URL}/list`, data)
    .then((response) => {
      return response.data
    }
    )
}

const getDownloadLink = (postData: any, cancelToken?: any): Promise<any> => {

  const data = parseRequestQuery(postData)
  const config = cancelToken ? { cancelToken } : {}
  return axios
    .post(`${API_URL}/list`, data, config)
    .then((response) => {
      return response.data
    }
    )
}

const getFilterOptions = (): Promise<any> => {
  return axios
    .get(`${API_URL}/filter-options`)
    .then((response) => {
      return response.data
    }
    )
};

const getProjectOptions = (data:any, config: any): Promise<any> => {
  return axios.post(`${API_URL}/project-list`, data, config).then((response) => response.data)
}

const fetchImage = (id, url) => {
  return axios
    .post(`${API_URL}/manual-update-website-image`, {
      id,
      url,
    })
    .then((response) => response?.data)
}

const getPortfolioByToken = (token: string): Promise<any> => {
  return axios
    .get(`${API_URL}/sharable/${token}`)
    .then((response) => response.data)
}

export {getFilterOptions, getDashboardData, getProjectOptions, getDownloadLink, fetchImage, getPortfolioByToken}
